import React, {useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';


function CheckoutCustomer() {
  const navigate = useNavigate();

  const [idSalesman, setIdSalesman] = useState('');
  const [checkOutTime, setCheckOutTime] = useState('');
  const [passwordCheckOut, setPasswordCheckOut] = useState('');

  const backFunction = () => {
    navigate('/');
  };

  const checkOutApi = async (idSalesman, checkOutTime) => {
    const requestBody = {
      idSalesman: idSalesman,
      outLat:  '123', 
      outLong:  '123', 
      timeOut: checkOutTime,
      passwordAuth : passwordCheckOut
    };

    try{
      const response = await fetch('https://api-sfasan.spsbijag.com/backend/backend_new/ScriptManagement/checkout_new.php', {
        mode: 'cors',
        method : 'POST',
        headers : {'Content-Type' : 'application/json'},
        body : JSON.stringify(requestBody),
      })

      const data = await response.json();
        if (data.success === true){
          alert("Sucess untuk checkout");
          navigate('/');
        } 
        else{
          alert(`Checkout failed: ${data.message || 'Unknown error'}`);
        }
      
    }
    catch(error){
      console.error('Error:', error);
      alert('An error occurred. Please try again later.');
    }

  }

  const submit = () => {
    if (idSalesman === '' || checkOutTime ===''){
      alert(`Isi terlebih dahulu! `);
      return;
    }
    confirmAlert({
      title: 'Konfirmasi Ulang',
      message: `Apakah Anda Yakin Ingin Mencheckoutkan Salesman : ${idSalesman} di Jam : ${checkOutTime} ? `,
      buttons: [
        {
          label: 'Yes',
          onClick: () => checkOutApi(idSalesman, checkOutTime)
        },
        {
          label: 'No',
          onClick: () => null
        }
      ]
    });
    
   
  };

  return (
    <div className="App">
      <header className="App-header">
        {/* Add a class 'back-button' to the button */}
        <button className="back-button" onClick={backFunction}>
          <FontAwesomeIcon icon={faArrowLeft} />
          back
        </button>
        <h1>Check Out Management</h1>
        <div className='input-row'>
          <h5>Id Salesman</h5>
          <input name = "idSalesman" 
          maxLength={8}
          value = {idSalesman} onChange={
            (e)=> setIdSalesman(e.target.value)
          }></input>
        </div>

        <div className='input-row'>
          <h5>CheckOut Time</h5>
          <input
            type="time"
            name="CheckOutTime"
            value={checkOutTime}
            onChange={(e) => setCheckOutTime(e.target.value)}
          />
        </div>

        <div className='input-row'>
          <h5>Password</h5>
        <input name = "password" type = "password" value = {passwordCheckOut} onChange={(e)=> setPasswordCheckOut(e.target.value)}></input>
        </div>
        <button onClick={submit}>Check Out Salesman</button>
      </header>
    </div>
  );
}

export default CheckoutCustomer;
